import { useState, useEffect } from "react";
import {
    Backdrop,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogTitle,
    Grid,
    Typography,
    TextField,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Checkbox,
    Collapse,
    Button,
    Box,
    Rating,
    FormControlLabel,
    useMediaQuery,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";

import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { serverTimestamp, setDoc, collection, getDoc, doc, updateDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet-async";

function ScinarioCreation() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [user, setUser] = useState("");
    const [params, setParams] = useState("");
    const [scina, setScina] = useState([]);
    const [maxNumber, setMaxNumber] = useState(0);
    const navigate = useNavigate();

    const isSP = useMediaQuery("(max-width:600px)");

    const [viewportHeight, setViewportHeight] = useState(0);

    const getTextFieldRows = () => {
        if (!viewportHeight) return 29;
        return Math.floor((viewportHeight - 300) / 22);
    };

    const [title, setTitle] = useState("");
    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const [accordionExpand, setAccordionExpand] = useState(false);
    const handleAccordionExpandChange = () => {
        setAccordionExpand(!accordionExpand);
    };

    const [expanded01, setExpanded01] = useState(true);
    const handleExpand01 = () => {
        setExpanded01(!expanded01);
    };

    const [expanded02, setExpanded02] = useState(true);
    const handleExpand02 = () => {
        setExpanded02(!expanded02);
    };

    const [expanded03, setExpanded03] = useState(true);
    const handleExpand03 = () => {
        setExpanded03(!expanded03);
    };

    const [kpInfo, setKpinfo] = useState([
        {
            id: 1,
            title: "概要",
            kpLevel: 0,
            plLevel: 0,
            numberPeople: "",
            playTime: "",
            infoContent: "",
        },
        { id: 2, title: "探索者について", skill: "", plContent: "" },
        { id: 3, title: "NPC情報", npcContent: "" },
        { id: 4, title: "アイテム等", itemContent: "" },
        { id: 5, title: "あらすじ", synopsisContent: "" },
        { id: 6, title: "真相", truthContent: "" },
    ]);

    const [stories, setStories] = useState([
        { id: 1, title: "導入", content: "" },
        { id: 2, title: "Item 2", content: "" },
        { id: 3, title: "Item 3", content: "" },
    ]);

    const [endings, setEndings] = useState([
        { id: 1, title: "Good End", content: "", reward: "" },
        { id: 2, title: "Bad End", content: "", reward: "" },
    ]);

    const [privacy, setPrivacy] = useState(false);
    const handlePrivacyChange = (event) => {
        setPrivacy(event.target.checked);
    };

    const [selectedInfoId, setSelectedInfoId] = useState(1);
    const handleInfoClick = (infoId) => {
        setSelectedInfoId(infoId);
        setSelectedStoryId(null);
        setSelectedEndId(null);
        setAccordionExpand(!accordionExpand);
    };

    const handleAddItem01 = () => {
        const maxID = stories.length > 0 ? Math.max(...stories.map((item) => item.id)) : 0;
        const newStories = {
            id: `${maxID + 1}`,
            title: `Item ${maxID + 1}`,
            content: ``,
        };
        setStories([...stories, newStories]);
    };

    const handleDeleteItem01 = (index) => {
        const updatedStories = [...stories];
        updatedStories.splice(index, 1);
        setStories(updatedStories);
    };

    const [selectedStoryId, setSelectedStoryId] = useState(null);
    const handleStoryClick = (storyId) => {
        setSelectedStoryId(storyId);
        setSelectedInfoId(null);
        setSelectedEndId(null);
        setAccordionExpand(!accordionExpand);
    };

    const handleAddItem02 = () => {
        const maxID = endings.length > 0 ? Math.max(...endings.map((item) => item.id)) : 0;
        const newEndings = {
            id: `${maxID + 1}`,
            title: `End ${maxID + 1}`,
            content: ``,
        };
        setEndings([...endings, newEndings]);
    };

    const handleDeleteItem02 = (index) => {
        const updatedEndings = [...endings];
        updatedEndings.splice(index, 1);
        setEndings(updatedEndings);
    };

    const [selectedEndId, setSelectedEndId] = useState(null);
    const handleEndClick = (endId) => {
        setSelectedEndId(endId);
        setSelectedInfoId(null);
        setSelectedStoryId(null);
        setAccordionExpand(!accordionExpand);
    };

    // KP情報始まり
    const handleKpRateChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[0].kpLevel = Number(event.target.value);
        setKpinfo(updatedKpInfo);
    };
    const handlePlRateChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[0].plLevel = Number(event.target.value);
        setKpinfo(updatedKpInfo);
    };
    const peopleChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[0].numberPeople = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const timeChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[0].playTime = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const overviewChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[0].infoContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const skillChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[1].skill = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const playerChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[1].plContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const npcChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[2].npcContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const toolChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[3].itemContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const synopsisChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[4].synopsisContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    const truthChange = (event) => {
        const updatedKpInfo = [...kpInfo];
        updatedKpInfo[5].truthContent = event.target.value;
        setKpinfo(updatedKpInfo);
    };
    // KP情報終わり

    // 本編始まり
    const handleStoryTitleChange = (storyId, event) => {
        const addStories = [...stories];
        const targetIndex = addStories.findIndex((story) => story.id === storyId);
        const targetStory = { ...addStories[targetIndex] };
        targetStory.title = event.target.value;
        addStories[targetIndex] = targetStory;
        setStories(addStories);
    };
    const handleStoryContentChange = (storyId, event) => {
        const addStories = [...stories];
        const targetIndex = addStories.findIndex((story) => story.id === storyId);
        const targetStory = { ...addStories[targetIndex] };
        targetStory.content = event.target.value;
        addStories[targetIndex] = targetStory;
        setStories(addStories);
    };
    // 本編終わり

    // エンディング始まり
    const handleEndingTitleChange = (endId, event) => {
        const addEndings = [...endings];
        const targetIndex = addEndings.findIndex((ending) => ending.id === endId);
        const targetEnding = { ...addEndings[targetIndex] };
        targetEnding.title = event.target.value;
        addEndings[targetIndex] = targetEnding;
        setEndings(addEndings);
    };

    const handleEndingContentChange = (endId, event) => {
        const addEndings = [...endings];
        const targetIndex = addEndings.findIndex((ending) => ending.id === endId);
        const targetEnding = { ...addEndings[targetIndex] };
        targetEnding.content = event.target.value;
        addEndings[targetIndex] = targetEnding;
        setEndings(addEndings);
    };
    const handleEndingRewardChange = (endId, event) => {
        const addEndings = [...endings];
        const targetIndex = addEndings.findIndex((ending) => ending.id === endId);
        const targetEnding = { ...addEndings[targetIndex] };
        targetEnding.reward = event.target.value;
        addEndings[targetIndex] = targetEnding;
        setEndings(addEndings);
    };
    // エンディング終わり

    // 保存処理
    const handleSave = async () => {
        setSaving(true);

        let randomId;
        let scinaSnap;
        do {
            randomId = Math.random().toString(36).substring(2, 12);

            const scinaRef = doc(db, "scinario", randomId);
            scinaSnap = await getDoc(scinaRef);
        } while (scinaSnap.exists());
        setParams(randomId);

        try {
            const memberRef = doc(db, "member", user);
            const scinaRef = doc(db, "scinario", randomId);
            const createDate = new Date();
            scina.push({
                id: maxNumber + 1,
                scinaId: randomId,
                createAt: createDate,
            });

            await setDoc(scinaRef, {
                id: randomId,
                title: title,
                kpInfo: kpInfo,
                stories: stories,
                endings: endings,
                private: privacy,
                clear: false,
                auther: user,
                updateAt: serverTimestamp(),
                createAt: serverTimestamp(),
                deleted: false,
                deleteAt: null,
            });

            await updateDoc(memberRef, {
                scinarios: scina,
                updateAt: serverTimestamp(),
            });

            setSaveOpen(true);
        } catch (error) {
            console.error("error: ", error);
            setSaving(false);
        }
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate(`/scinario/${params}`, { replace: true });
    };

    const fetchData = async (uid) => {
        const userRef = collection(db, "member");
        const userDoc = doc(userRef, uid);
        const userSnapshot = await getDoc(userDoc);

        if (userSnapshot.exists()) {
            let scinaList = userSnapshot.data().scinarios;
            setScina(userSnapshot.data().scinarios);

            if (scinaList !== undefined) {
                const maxScinaId = Math.max(...scinaList.map((item) => item.id));
                if (maxScinaId === -Infinity) {
                    setMaxNumber(0);
                } else {
                    setMaxNumber(maxScinaId);
                }
            }
        }

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                const uid = userLogin.uid;
                setUser(uid);
                await fetchData(uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        // 画面の高さを取得
        const updateViewportHeight = () => {
            setViewportHeight(window.innerHeight);
        };

        updateViewportHeight();
        window.addEventListener("resize", updateViewportHeight);

        return () => {
            unsubscribe();
            window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Scinario Create - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                {isSP ? (
                    <Box>
                        <Accordion
                            expanded={accordionExpand}
                            onChange={handleAccordionExpandChange}
                            sx={{ maxHeight: `calc(${viewportHeight}px - 80px)` }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>メニュー</AccordionSummary>
                            <AccordionDetails>
                                <TextField label="タイトル" variant="filled" value={title} onChange={handleTitleChange} fullWidth />
                                <Box
                                    sx={{
                                        maxHeight: `calc(${viewportHeight}px - 310px)`,
                                        overflow: "auto",
                                        mt: 2,
                                    }}
                                >
                                    <FormControlLabel
                                        onChange={handlePrivacyChange}
                                        checked={privacy}
                                        label="公開"
                                        labelPlacement="end"
                                        control={<Checkbox />}
                                        sx={{
                                            maxWidth: "300px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "fit-content",
                                            "& .MuiFormControlLabel-label": {
                                                whiteSpace: "nowrap",
                                            },
                                        }}
                                    />

                                    <List sx={{ mt: 2 }}>
                                        <ListItemButton onClick={handleExpand01}>
                                            <ListItemText primary="キーパー情報" />
                                            {expanded01 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded01} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {kpInfo.map((info) => (
                                                    <ListItemButton
                                                        key={info.id}
                                                        onClick={() => handleInfoClick(info.id)}
                                                        selected={selectedInfoId === info.id}
                                                    >
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={`${info.title}`} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </List>

                                    <List>
                                        <ListItemButton onClick={handleExpand02}>
                                            <ListItemText primary="本編" />
                                            {expanded02 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded02} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {stories.map(({ id, title }, index) => (
                                                    <ListItemButton key={id} onClick={() => handleStoryClick(id)} selected={selectedStoryId === id}>
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={title} />
                                                        <IconButton edge="end" onClick={() => handleDeleteItem01(index)}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                            <Box
                                                sx={{ my: 2 }}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Button color="info" variant="outlined" onClick={handleAddItem01}>
                                                    <AddIcon />
                                                </Button>
                                            </Box>
                                        </Collapse>
                                    </List>

                                    <List>
                                        <ListItemButton onClick={handleExpand03}>
                                            <ListItemText primary="エンディング" />
                                            {expanded03 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded03} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {endings.map(({ id, title }, index) => (
                                                    <ListItemButton key={id} onClick={() => handleEndClick(id)} selected={selectedEndId === id}>
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={title} />
                                                        <IconButton edge="end" onClick={() => handleDeleteItem02(index)}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                            <Box
                                                sx={{ my: 2 }}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Button color="info" variant="outlined" onClick={handleAddItem02}>
                                                    <AddIcon />
                                                </Button>
                                            </Box>
                                        </Collapse>
                                    </List>
                                </Box>

                                <Box
                                    sx={{ my: 2 }}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button sx={{ mx: 1, py: 1, width: 190 }} color="primary" variant="contained" onClick={handleSave}>
                                        <SaveIcon sx={{ mx: 1 }} /> 保存
                                    </Button>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        {selectedInfoId === 1 ? (
                            <div>
                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                    <Grid item xs={6}>
                                        <Typography sx={{ textAlign: "center" }}>キーパー難易度</Typography>
                                        <Rating
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                            }}
                                            value={kpInfo[0].kpLevel}
                                            onChange={handleKpRateChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography sx={{ textAlign: "center" }}>プレイヤー難易度</Typography>
                                        <Rating
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                            }}
                                            value={kpInfo[0].plLevel}
                                            onChange={handlePlRateChange}
                                        />
                                    </Grid>
                                </Grid>
                                <TextField
                                    label="推奨人数"
                                    variant="filled"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    value={kpInfo[0].numberPeople}
                                    onChange={peopleChange}
                                />
                                <TextField
                                    label="プレイ時間"
                                    variant="filled"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    value={kpInfo[0].playTime}
                                    onChange={timeChange}
                                />
                                <TextField
                                    label="シナリオの概要"
                                    variant="filled"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 370px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={kpInfo[0].infoContent}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                    onChange={overviewChange}
                                />
                            </div>
                        ) : selectedInfoId === 2 ? (
                            <div>
                                <TextField
                                    label="技能について"
                                    placeholder="推奨技能などがあれば、記載してください"
                                    variant="filled"
                                    sx={{ mt: 2 }}
                                    value={kpInfo[1].skill}
                                    onChange={skillChange}
                                    multiline
                                    rows={5}
                                    fullWidth
                                />

                                <TextField
                                    label="探索者について"
                                    placeholder="職業の指定や、年齢制限、ハンドアウトなどあれば、記載してください"
                                    variant="filled"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 310px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={kpInfo[1].plContent}
                                    onChange={playerChange}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                />
                            </div>
                        ) : selectedInfoId === 3 ? (
                            <TextField
                                label="NPC情報"
                                variant="filled"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 150px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo[2].npcContent}
                                onChange={npcChange}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                            />
                        ) : selectedInfoId === 4 ? (
                            <TextField
                                label="アイテム等"
                                variant="filled"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 150px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo[3].itemContent}
                                onChange={toolChange}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                            />
                        ) : selectedInfoId === 5 ? (
                            <TextField
                                label="あらすじ"
                                variant="filled"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 150px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo[4].synopsisContent}
                                onChange={synopsisChange}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                            />
                        ) : selectedInfoId === 6 ? (
                            <div>
                                <TextField
                                    label="真相"
                                    variant="filled"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 150px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={kpInfo[5].truthContent}
                                    onChange={truthChange}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                />
                            </div>
                        ) : selectedStoryId !== null ? (
                            <div>
                                <TextField
                                    label="タイトル"
                                    variant="filled"
                                    sx={{ mt: 2 }}
                                    value={stories.find((story) => story.id === selectedStoryId)?.title || ""}
                                    onChange={(event) => handleStoryTitleChange(selectedStoryId, event)}
                                    fullWidth
                                />

                                <TextField
                                    label="内容"
                                    variant="filled"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 220px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={stories.find((story) => story.id === selectedStoryId)?.content || ""}
                                    onChange={(event) => handleStoryContentChange(selectedStoryId, event)}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                />
                            </div>
                        ) : selectedEndId !== null ? (
                            <div>
                                <TextField
                                    label="タイトル"
                                    variant="filled"
                                    sx={{ mt: 2 }}
                                    value={endings.find((end) => end.id === selectedEndId)?.title || ""}
                                    onChange={(event) => handleEndingTitleChange(selectedEndId, event)}
                                    fullWidth
                                />

                                <TextField
                                    label="内容"
                                    variant="filled"
                                    sx={{
                                        mt: 2,
                                        height: "calc(100vh - 410px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={endings.find((end) => end.id === selectedEndId)?.content || ""}
                                    onChange={(event) => handleEndingContentChange(selectedEndId, event)}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                />

                                <TextField
                                    label="クリア報酬"
                                    variant="filled"
                                    sx={{ mt: 2, mb: 2 }}
                                    value={endings.find((end) => end.id === selectedEndId)?.reward || ""}
                                    onChange={(event) => handleEndingRewardChange(selectedEndId, event)}
                                    multiline
                                    rows={6}
                                    fullWidth
                                />
                            </div>
                        ) : (
                            <div>
                                <Box></Box>
                            </div>
                        )}
                    </Box>
                ) : (
                    <Grid container spacing={4} sx={{ mt: 8, height: `calc(${viewportHeight}px - 100px)` }}>
                        <Grid item sm={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <TextField label="タイトル" variant="filled" value={title} onChange={handleTitleChange} fullWidth />
                            <Box
                                sx={{
                                    flex: 1,
                                    overflow: "auto",
                                    mt: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <FormControlLabel
                                    onChange={handlePrivacyChange}
                                    checked={privacy}
                                    label="公開"
                                    labelPlacement="end"
                                    control={<Checkbox />}
                                    sx={{
                                        maxWidth: "250px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "fit-content",
                                        "& .MuiFormControlLabel-label": {
                                            whiteSpace: "nowrap",
                                        },
                                    }}
                                />

                                <List sx={{ mt: 2 }}>
                                    <ListItemButton onClick={handleExpand01}>
                                        <ListItemText primary="キーパー情報" />
                                        {expanded01 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded01} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {kpInfo.map((info) => (
                                                <ListItemButton
                                                    key={info.id}
                                                    onClick={() => handleInfoClick(info.id)}
                                                    selected={selectedInfoId === info.id}
                                                >
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={`${info.title}`} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </List>

                                <List>
                                    <ListItemButton onClick={handleExpand02}>
                                        <ListItemText primary="本編" />
                                        {expanded02 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded02} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {stories.map(({ id, title }, index) => (
                                                <ListItemButton key={id} onClick={() => handleStoryClick(id)} selected={selectedStoryId === id}>
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={title} />
                                                    <IconButton edge="end" onClick={() => handleDeleteItem01(index)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </ListItemButton>
                                            ))}
                                        </List>
                                        <Box
                                            sx={{ my: 2 }}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Button color="info" variant="outlined" onClick={handleAddItem01}>
                                                <AddIcon />
                                            </Button>
                                        </Box>
                                    </Collapse>
                                </List>

                                <List>
                                    <ListItemButton onClick={handleExpand03}>
                                        <ListItemText primary="エンディング" />
                                        {expanded03 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded03} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {endings.map(({ id, title }, index) => (
                                                <ListItemButton key={id} onClick={() => handleEndClick(id)} selected={selectedEndId === id}>
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={title} />
                                                    <IconButton edge="end" onClick={() => handleDeleteItem02(index)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </ListItemButton>
                                            ))}
                                        </List>
                                        <Box
                                            sx={{ my: 2 }}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Button color="info" variant="outlined" onClick={handleAddItem02}>
                                                <AddIcon />
                                            </Button>
                                        </Box>
                                    </Collapse>
                                </List>
                            </Box>

                            <Box
                                sx={{ my: 2 }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Button sx={{ mx: 1, py: 1, width: 190 }} color="primary" variant="contained" onClick={handleSave}>
                                    <SaveIcon sx={{ mx: 1 }} /> 保存
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item sm={9} sx={{ height: "100%", overflowY: "auto" }}>
                            {selectedInfoId === 1 ? (
                                <div>
                                    <Grid
                                        container
                                        spacing={0}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Grid item sm={3}>
                                            <Typography>キーパー難易度</Typography>
                                            <Rating value={kpInfo[0].kpLevel} onChange={handleKpRateChange} />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Typography>プレイヤー難易度</Typography>
                                            <Rating value={kpInfo[0].plLevel} onChange={handlePlRateChange} />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <TextField label="推奨人数" variant="filled" value={kpInfo[0].numberPeople} onChange={peopleChange} />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <TextField label="プレイ時間" variant="filled" value={kpInfo[0].playTime} onChange={timeChange} />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ mt: 3 }}>
                                        <TextField
                                            label="シナリオの概要"
                                            variant="filled"
                                            value={kpInfo[0].infoContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            onChange={overviewChange}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 2 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <TextField
                                        label="技能について"
                                        placeholder="推奨技能などがあれば、記載してください"
                                        variant="filled"
                                        value={kpInfo[1].skill}
                                        onChange={skillChange}
                                        multiline
                                        rows={3}
                                        sx={{ mb: 4, flex: "0 0 100px" }}
                                        fullWidth
                                        InputProps={{
                                            style: { alignItems: "flex-start" },
                                        }}
                                    />
                                    <TextField
                                        label="探索者について"
                                        placeholder="職業の指定や、年齢制限、ハンドアウトなどあれば、記載してください"
                                        variant="filled"
                                        value={kpInfo[1].plContent}
                                        onChange={playerChange}
                                        multiline
                                        sx={{
                                            flex: 1,
                                            height: "calc(100vh - 400px)",
                                            "& .MuiInputBase-root": {
                                                height: "100%",
                                                overflow: "auto",
                                                "& textarea": {
                                                    height: "100% !important",
                                                    overflow: "auto !important",
                                                },
                                            },
                                        }}
                                        fullWidth
                                        InputProps={{
                                            style: { height: "100%", alignItems: "flex-start" },
                                        }}
                                    />
                                </div>
                            ) : selectedInfoId === 3 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="NPC情報"
                                            variant="filled"
                                            value={kpInfo[2].npcContent}
                                            onChange={npcChange}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 4 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="アイテム等"
                                            variant="filled"
                                            value={kpInfo[3].itemContent}
                                            onChange={toolChange}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 5 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="あらすじ"
                                            variant="filled"
                                            value={kpInfo[4].synopsisContent}
                                            onChange={synopsisChange}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 6 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="真相"
                                            variant="filled"
                                            value={kpInfo[5].truthContent}
                                            onChange={truthChange}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedStoryId !== null ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="タイトル"
                                            variant="filled"
                                            value={stories.find((story) => story.id === selectedStoryId)?.title || ""}
                                            onChange={(event) => handleStoryTitleChange(selectedStoryId, event)}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box sx={{ my: 3 }}>
                                        <TextField
                                            label="内容"
                                            variant="filled"
                                            value={stories.find((story) => story.id === selectedStoryId)?.content || ""}
                                            onChange={(event) => handleStoryContentChange(selectedStoryId, event)}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                        />
                                    </Box>
                                </div>
                            ) : selectedEndId !== null ? (
                                <div style={{ height: "calc(100vh - 250px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="タイトル"
                                            variant="filled"
                                            value={endings.find((end) => end.id === selectedEndId)?.title || ""}
                                            onChange={(event) => handleEndingTitleChange(selectedEndId, event)}
                                            fullWidth
                                        />
                                    </Box>
                                    <Box sx={{ my: 3 }}>
                                        <TextField
                                            label="内容"
                                            variant="filled"
                                            value={endings.find((end) => end.id === selectedEndId)?.content || ""}
                                            onChange={(event) => handleEndingContentChange(selectedEndId, event)}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "calc(100vh - 400px)",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                        overflow: "auto !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TextField
                                            label="クリア報酬"
                                            variant="filled"
                                            value={endings.find((end) => end.id === selectedEndId)?.reward || ""}
                                            onChange={(event) => handleEndingRewardChange(selectedEndId, event)}
                                            multiline
                                            rows={5}
                                            fullWidth
                                        />
                                    </Box>
                                </div>
                            ) : (
                                <div>
                                    <Box></Box>
                                </div>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Container>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={saving}
            >
                <CircularProgress size="3rem" />
            </Backdrop>

            {/* 保存完了のダイアログ */}
            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    作成しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ScinarioCreation;
